'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('../helpers/utils');

var _bind = require('../mixins/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DOM selectors.
 */
/**
 * Component: Quantity selector
 * ------------------------------------------------------------------------------
 * A form control component to increment/decrement a counter.
 *
 * @namespace quantitySelector
 */
var selectors = {
  decrement: '[js-quantity-selector="decrement"]',
  increment: '[js-quantity-selector="increment"]',
  input: '[js-quantity-selector="input"]'
};

/**
 * Create a new quantitySelector object.
 * @param {string} selector - Node id selector.
 * @param {Function} callback - Callback function executed after a quantity update.
 */

exports.default = function (selector) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


  /**
   * Instance settings.
   */
  var namespace = selector;
  var container = document.getElementById(selector);

  /**
   * Node selectors.
   */
  var nodeSelectors = {
    decrement: container.querySelector(selectors.decrement),
    increment: container.querySelector(selectors.increment),
    input: container.querySelector(selectors.input)
  };

  /**
   * Initialise component bind.
   */
  var binder = (0, _bind2.default)(container);

  /**
   * Initialise component.
   */
  function init() {
    if (binder.isSet()) {
      return;
    }

    setListeners();
    setTriggerEvents();
    binder.set();
  }

  /**
   * Set listeners for each instance.
   */
  function setListeners() {
    Frame.EventBus.listen(namespace + ':update', function (value) {
      update(value);
      executeCallback();
    });
  }

  /**
   * Set click listeners.
   */
  function setTriggerEvents() {
    (0, _utils.on)('click', nodeSelectors.increment, function (event) {
      return handleQuantityUpdate('increment', event);
    });
    (0, _utils.on)('click', nodeSelectors.decrement, function (event) {
      return handleQuantityUpdate('decrement', event);
    });
  }

  /**
   * Handle quantity updates.
   * @param {string} type - Quantity update type (increment/decrement).
   * @param {Event} event - Click event.
   */
  function handleQuantityUpdate(type, event) {
    event.preventDefault();
    var inputValue = nodeSelectors.input.value;
    var currentValue = type === 'increment' ? parseInt(inputValue, 10) + 1 : parseInt(inputValue, 10) - 1;

    if (validate(currentValue)) {
      Frame.EventBus.emit(namespace + ':update', currentValue);
    }
  }

  /**
   * Validate input.
   * @param {Integer} value - Value to validate.
   */
  function validate(value) {
    return !isNaN(value) && value >= 1;
  }

  /**
   * Update DOM value and execute callback.
   * @param {Integer} value - Value to replace on DOM.
   */
  function update(value) {
    nodeSelectors.input.setAttribute('value', value);
  }

  /**
   * Execute callback function defined in constructor.
   */
  function executeCallback() {
    return typeof callback === 'function' ? callback() : false;
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init: init,
    update: update
  });
};